export const chartReportConfigs = {
  "Account Overview": {
    chartSource: "account overview chart",
    chart: { type: "BAR", xKey: "WEEK_START", yKey: "CHARGE_AMOUNT" }
  },
  "Duplicate Billing": {
    chartSource: "duplicate billing",
    chart: { type: "BAR", xKey: "WEEK_OF_INVOICE_DATE", yKey: "CHARGE_AMOUNT" }
  },
  "Late Payment Fees": {
    chartSource: "late payment fees",
    chart: { type: "BAR", xKey: "InvoiceDate", yKey: "ChargeAmount" }
  },
  "cost analysis weekly": {
    chartSource: "Weekly Charge Spend",
    chart: { type: "LINE", xKey: "WEEK", yKey: "CHARGE_AMOUNT" }
  },
  "cost analysis carrier": {
    chartSource: "Charge Spend by Carrier",
    chart: { type: "BAR", xKey: "CARRIER", yKey: "CHARGE_AMOUNT" }
  },
  "Zone Summary": {
    chartSource: "zone summary",
    chart: { 
      type: "HEAT-MAP-GRID", 
      xKey: "ZONE", 
      yKey: "WEIGHT", 
      valueKey: "VALUE", 
      xOrder: [2, 3, 4, 5, 6, 7, 8, "AK/HI", "Int'l"]
     }
  },
  "Inactive Accounts": {
    chartSource: "Inactive Accounts",
    chart: { type: "LINE", xKey: "INVOICE_WEEK", yKey: "WEEK_TOTAL" }
  },
  "Parcel Invoice": {
    chartSource: "Parcel Invoice",
    chart: { type: "BAR", xKey: "INVOICE_WEEK", yKey: "CHARGE_AMOUNT" }
  },
  "UPS RFP": {
    chartSource: "UPS RFP",
    chart: { type: "TABLE-WRAPPED" },
    pdf: {
      highlightColumns: [
        { key: "SAVINGS", styles: { fontSize: 12, fontStyle: "bold", textColor: '#85BB65' } },
      ],
      title: "UPS RFP Savings"
    }
  },
  "FedEx RFP": {
    chartSource: "FedEx RFP",
    chart: { type: "TABLE-WRAPPED" },
    pdf: {
      highlightColumns: [
        { key: "SAVINGS", styles: { fontSize: 12, fontStyle: "bold", textColor: '#85BB65' } },
      ],
      title: "FedEx RFP Savings"
    }
  },
  "RFP AREA CHART": {
    chartSource: "Benchmark VS New Cost VS Savings",
    chart: { type: "MULTI-AREA-CHART" }
  },
  "MICRODENTAL RFP": {
    chartSource: "Savings By Lab",
    chart: { type:"TABLE-WRAPPED"  },
    pdf: {
      highlightColumns: [
        { key: "SAVINGS", styles: { fontSize: 12, fontStyle: "bold", textColor: '#85BB65' } },
      ],
      title: "MicroDental RFP Savings"
    }
  }
};
 